import React from "react";
import "./about.css";

import { GiGraduateCap } from "react-icons/gi";
import { BsBookmarkStar } from "react-icons/bs";
import { TfiWorld } from "react-icons/tfi";

const About = () => {
  return (
    <section id="about">
      <h2>
        About Me <span className="dot">.</span>{" "}
      </h2>

      <div className="container about__container">
        <lord-icon
          src="https://cdn.lordicon.com/noobabzt.json"
          trigger="loop"
          state="loop-line"
          stroke="light"
          colors="primary:#aadcec,secondary:#6000cb,tertiary:#aadcec"
          style={{ width: "350px", height: "350px" }}
        ></lord-icon>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <GiGraduateCap className="about__icon" />
              <h5>Educational Background</h5>
              <small>Bachelor of Engineering in Computer Science, [RGPV]</small>
            </article>

            <article className="about__card">
              <TfiWorld className="about__icon" />
              <h5>Domains</h5>
              <small>
                <ul>
                  <li>Full Stack Development</li>
                  <li>Mobile Applications</li>
                </ul>
              </small>
            </article>
            <article className="about__card">
              <BsBookmarkStar className="about__icon" />
              <h5>Experience (Years)</h5>
              <small>4.5+</small>
            </article>
          </div>
          <p>
            <b>I am currently a Senior Software Engineer at Cybage Software</b>,
            where I undertake a variety of roles and responsibilities in
            front-end development. My work involves designing and implementing
            user interfaces, optimizing web performance, and ensuring seamless
            user experiences. I collaborate closely with cross-functional teams
            to deliver high-quality software solutions that meet client
            requirements.
          </p>

          <p>
            Prior to my current role, I was part of <b>Coforge Pvt Ltd</b>,
            where I honed my skills in software development and gained valuable
            industry experience.
          </p>

          <p>
            I am a dedicated and proactive professional with a robust foundation
            in software engineering, always eager to tackle new challenges and
            contribute to innovative projects. My hands-on experience with
            various programming languages and my ability to quickly learn and
            adapt enable me to consistently deliver exceptional results.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
